export default function initSmoothAnchorScroll () {
  console.log(window.location.href.replace(window.location.hash, ''))
  const url = window.location.href.replace(window.location.hash, '').replace(/\/+$/, '')

  document.querySelectorAll(`a[href^="#"], a[href^="${url}#"], a[href^="${url}/#"]`).forEach(anchor => {
    console.log('anchor', anchor)
    anchor.addEventListener('click', function (e) {
      const id = this.getAttribute('href').split('#')[1]
      if (id) {
        const element = document.getElementById(id)
        if (element) {
          e.preventDefault()
          element.scrollIntoView({
            behavior: 'smooth'
          })
        }
      } else {
        e.preventDefault()
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    })
  })
}
